import { SCENARIO_DESCRIPTOR } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(SCENARIO_DESCRIPTOR);
const actions = { ...rawActions, ...thunkFactory(SCENARIO_DESCRIPTOR, '/cenariodescritor/') };
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(SCENARIO_DESCRIPTOR, initialState);

// SAGAS
const sagas = sagasFactory(SCENARIO_DESCRIPTOR, '/cenariodescritor/');
export { sagas };
